module.exports = __webpack_public_path__ + "img/60.80f52c94.jpg";